import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { fetchAward, resetAward } from "../../actions/awardAction";
import { withRouter } from "react-router-dom";
import { openModal } from "../../actions/modalAction";
import { Form, Button } from "semantic-ui-react";
import TextInput from "../form/TextInput";
import NumberInput from "../form/NumberInput";
// import SelectInput from "../form/SelectInput";

import {
  //composeValidators,
  combineValidators,
  isRequired,
} from "revalidate";

//
const validate = combineValidators({
  head: isRequired("Heading"),
});

//

class AwardEdit extends Component {
  componentDidMount() {
    const { id } = this.props;
    this.props.fetchAward(id);
  }
  componentWillUnmount() {
    this.props.resetAward();
  }
  onSubmit = async (values) => {
    //************
    try {
      const { id } = this.props;
      const res = await axios.put(`/api/AwardEdit/${id}`, values);

      if (res.data.msg === "success") {
        toastr.success("Updated Successfully");
        this.props.handleEditModalCloseSubmit();
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        console.log("error_edit_review", error);
        toastr.error("Oops", "Something went wrong.Please Try Again_EditAward");
      }
    }
    //**********
  };

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    return (
      <div
        className="card-form border-radius marginBottom min-max-width"
        style={{ margin: "auto" }}
      >
        <div>
          <div className="">
            {/**/}

            <div
              style={{
                textAlign: "center",
                fontSize: "1.5rem",
                fontWeight: "bold",
                padding: "15px",
                color: "dodgerblue",
              }}
            >
              {/*  */}
              Edit Award
              {/*  */}
            </div>

            {/**/}
            <div className=" label">
              <Form
                style={{ padding: 20 }}
                onSubmit={handleSubmit(this.onSubmit)}
              >
                <br />
                <div>
                  <span className="color-mandatory">* </span>Mandatory Fields
                </div>
                <label>Heading</label>
                <span className="color-mandatory"> * </span>
                <Field
                  name="head"
                  type="text"
                  component={TextInput}
                  placeholder="Heading"
                />

                <label>Position</label>
                <Field
                  name="position"
                  type="number"
                  component={NumberInput}
                  placeholder="1/2/3 so on"
                />

                <br />

                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Submit
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
                <Button
                  color="teal"
                  type="button"
                  onClick={this.props.handleEditModalClose}
                >
                  Cancel
                </Button>

                <br />
              </Form>
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
    awards: state.awards.awards,
    initialValues: state.awards.award,
    award: state.awards.award,
  };
};

export default connect(mapStateToProps, {
  fetchAward,
  resetAward,
  openModal,
})(
  reduxForm({
    form: "AwardEdit", // a unique identifier for this form
    validate,
  })(withRouter(AwardEdit))
);
